import React from 'react';
import TextAreaInput from '../../../../elements/forms/TextAreaInput';
import { useCallback } from 'react';

function LeadNotes(props) {
    const { lead, onChange } = props,
        { note } = lead ?? {};

    const handleNotesChange = useCallback((note) => {
        onChange({ note });
    }, [onChange]);

    return <TextAreaInput value={note} onChange={handleNotesChange} />;
}

export default LeadNotes;
